import * as React from 'react';
import {useEffect} from 'react';
import {generateGUID} from 'src/js/common/utils';
import {DlError} from 'src/js/model/error';
import {useAppDispatch, useAppSelector} from 'src/js/store_hooks';

import {StatusBox} from './StatusBox';
import {STATUS_REDUCER_STATE_ID} from '../status_constants';
import {getLatestError} from '../status_selectors';
import {addError} from '../status_thunks';

interface OwnProps {
  applicationLabel?: string;
  isShrank?: boolean;
  version?: string;
}

type Props = OwnProps;

export const StatusContainer: React.FC<Props> = (props) => {
  const {applicationLabel = '', isShrank = false, version = ''} = props;
  const errors = useAppSelector((state) => state[STATUS_REDUCER_STATE_ID].errors);
  const latestError = useAppSelector((state) => getLatestError(state));
  const dispatch = useAppDispatch();

  useEffect(() => {
    const errorHandler = (e) => {
      let error = e.error || e || {};
      if (!(error instanceof DlError)) {
        // create DlError if it is not already passed
        error = new DlError(error, generateGUID(), 'GENERAL', e.timestamp);
      }
      dispatch(addError(error));
    };

    window.addEventListener('error', errorHandler);
    return () => {
      window.removeEventListener('error', errorHandler);
    };
  }, [dispatch]);

  return <StatusBox applicationLabel={applicationLabel} errors={errors} isShrank={isShrank} latestError={latestError} version={version} />;
};

StatusContainer.displayName = 'StatusContainer';
